










import { defineComponent } from '@nuxtjs/composition-api';

interface Props extends Blok {
  region: string;
  portalId: string;
  formId: string;
  width: string;
  formSubmitSnippet?: string;
  onFormReadySnippet?: string;
  formSubmittedSnippet?: string;
}

export default defineComponent({
  props: {
    blok: {
      type: Object as () => Props,
      required: true,
    },
  },
  head: {
    script: [
      {
        src: 'https://code.jquery.com/jquery-3.6.0.slim.min.js',
      },
      {
        src: 'https://js.hsforms.net/forms/v2.js',
        body: true,
      },
    ],
  },
  mounted() {
    const vm = this;
    const {
      region,
      portalId,
      formId,
      formSubmitSnippet,
      formSubmittedSnippet,
      onFormReadySnippet,
    } = this.blok;

    (window as any).hbspt.forms.create({
      region,
      portalId,
      formId,
      target: `#hbspt-form-${formId}`,
      onFormSubmit: function ($form: any[]) {
        vm.$emit('submit', $form[0]);
        if (formSubmitSnippet) {
          // eslint-disable-next-line no-eval
          eval(formSubmitSnippet);
        }
      },
      // eslint-disable-next-line
      onFormSubmitted: function ($form: any[]) {
        if (formSubmittedSnippet) {
          // eslint-disable-next-line no-eval
          eval(formSubmittedSnippet);
        }
      },
      // eslint-disable-next-line
      onFormReady: function ($form: any[]) {
        if (onFormReadySnippet) {
          // eslint-disable-next-line no-eval
          eval(onFormReadySnippet);
        }
      },
    });
  },
});
